import Image from 'next/image';

import { cn } from '@kit/ui/utils';

const PHOTO = '/images/about/IMG_7945.jpeg';
const NAME = 'Jakub Gierłachowski';
const PHOTO_ALT = 'Jakub Gierłachowski – twórca LEKolizji';
const LINKEDIN_URL = 'https://www.linkedin.com/in/-kuba/';
const CONTACT_PATH = '/contact';
const BIO_PARAGRAPHS = [
  'Jestem matematykiem i od ponad 10 lat pracuję w obszarze sztucznej inteligencji. Przez ponad 5 lat rozwijałem rozwiązania AI w dużej szwajcarskiej firmie farmaceutycznej.',
  'LEKolizję stworzyłem, bo wiedziałem, że dziś da się zrobić to lepiej. Zależało mi na narzędziu, które pomaga szybciej i wygodniej pracować z informacjami o interakcjach lekowych, ale bez odchodzenia od tego, co najważniejsze - treści zawartych w ChPL.',
  'Po pracy najchętniej spędzam czas w górach albo na korcie do squasha.',
];

const PILLS = ['Matematyk', '10+ lat w AI', '5+ lat w farmacji'];

const ICON_CLASS =
  'flex h-6 w-6 items-center justify-center rounded-md border border-[#d5d0c8] bg-stone-50 text-stone-600 shadow-[1px_1px_0_0_#d5d0c8] transition-all hover:translate-x-px hover:translate-y-px hover:shadow-none hover:text-stone-600 dark:border-stone-700 dark:bg-stone-800 dark:text-stone-500 dark:shadow-[1px_1px_0_0_#44403c] dark:hover:text-stone-300';

function SectionTitle() {
  return (
    <div className="mb-6 flex items-center justify-center sm:mb-8">
      <div className="inline-flex items-center gap-2.5">
        <span
          aria-hidden="true"
          className="h-px w-10 bg-slate-300 dark:bg-slate-600"
        />
        <h2 className="font-heading relative -skew-x-3 px-2 py-0.5 text-sm font-semibold tracking-[0.08em] text-slate-700 uppercase italic sm:text-base dark:text-slate-200">
          <span
            aria-hidden="true"
            className="absolute right-0 bottom-0 left-0 h-[0.8em] -skew-x-3 rounded-[2px] bg-green-300/70 dark:bg-green-500/25"
          />
          <span className="relative z-10">O twórcy</span>
        </h2>
        <span
          aria-hidden="true"
          className="h-px w-10 bg-slate-300 dark:bg-slate-600"
        />
      </div>
    </div>
  );
}

function Pills() {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {PILLS.map((pill) => (
        <span
          key={pill}
          className="rounded-md bg-stone-100 px-2.5 py-0.5 text-xs font-medium text-slate-500 dark:bg-slate-800 dark:text-slate-400"
        >
          {pill}
        </span>
      ))}
    </div>
  );
}

function SocialIcons({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <a
        href={CONTACT_PATH}
        className={ICON_CLASS}
        aria-label="Kontakt telefoniczny"
      >
        <svg
          className="h-3 w-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      </a>
      <a href={CONTACT_PATH} className={ICON_CLASS} aria-label="Kontakt email">
        <svg
          className="h-3 w-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
      </a>
      <a
        href={LINKEDIN_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={ICON_CLASS}
        aria-label="LinkedIn"
      >
        <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      </a>
    </div>
  );
}

function BioParagraphs() {
  return (
    <div className="space-y-2 text-justify text-[13px] leading-relaxed text-slate-500 dark:text-slate-300">
      {BIO_PARAGRAPHS.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </div>
  );
}

export function HomeAboutSection({
  className,
  hideTitle,
}: {
  className?: string;
  hideTitle?: boolean;
}) {
  return (
    <section
      aria-label="O twórcy"
      className={cn(
        'w-full bg-[#f7f5ef]/60 px-4 py-8 sm:py-10 dark:bg-stone-900/50',
        className,
      )}
    >
      {!hideTitle && <SectionTitle />}
      <div className="mx-auto max-w-2xl">
        <div className="rounded-xl border-2 border-[#d5d0c8] bg-[#fffef9] shadow-[3px_3px_0_0_#d5d0c8] dark:border-stone-700 dark:bg-stone-800/50 dark:shadow-[3px_3px_0_0_#44403c]">
          {/* ── Mobile layout ── */}
          <div className="p-5 sm:hidden">
            <div className="flex items-start gap-4">
              <div className="relative h-28 w-[86px] shrink-0 overflow-hidden rounded-xl shadow-lg shadow-stone-400/30 dark:shadow-black/40">
                <Image
                  src={PHOTO}
                  alt={PHOTO_ALT}
                  fill
                  className="object-cover object-top"
                  sizes="86px"
                />
              </div>
              <div className="min-w-0">
                <p className="font-heading text-lg font-bold text-slate-800 dark:text-slate-50">
                  {NAME}
                </p>
                <div className="mt-1.5">
                  <Pills />
                </div>
                <SocialIcons className="mt-2" />
              </div>
            </div>
            <div className="mt-4">
              <BioParagraphs />
            </div>
          </div>

          {/* ── Desktop layout ── */}
          <div className="hidden sm:flex sm:items-stretch">
            <div className="flex shrink-0 flex-col items-center justify-center p-5 pt-8">
              <div className="relative h-52 w-40 overflow-hidden rounded-2xl shadow-lg shadow-stone-400/30 dark:shadow-black/40">
                <Image
                  src={PHOTO}
                  alt={PHOTO_ALT}
                  fill
                  className="object-cover object-top"
                  sizes="160px"
                />
              </div>
              <SocialIcons className="mt-5" />
            </div>
            <div className="w-px self-stretch border-l border-dashed border-slate-200 dark:border-slate-700" />
            <div className="flex min-w-0 flex-col justify-center p-6">
              <p className="font-heading text-2xl font-bold text-slate-800 dark:text-slate-50">
                {NAME}
              </p>
              <div className="mt-2">
                <Pills />
              </div>
              <div className="mt-3">
                <BioParagraphs />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
